import { Component, OnInit, ElementRef, ViewEncapsulation, forwardRef, Renderer, Injector } from '@angular/core';
import { UploaderSettings, BaseAbstractControl } from 'moh-package';
import { FormGroup, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, FormArray } from '@angular/forms';

@Component({
  selector: 'moh-clm-claim',
  templateUrl: './clm-claim.component.html',
  styleUrls: ['./clm-claim.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ClmClaimComponent), multi: true, },
    { provide: NG_VALIDATORS, multi: true, useExisting: forwardRef(() => ClmClaimComponent) }]
})
export class ClmClaimComponent extends BaseAbstractControl implements OnInit {

  SinceYearsList: any[] = [1950, 1951, 1953, 1953, 1954, 2010, 2011, 2012];
  DuringList: any[] = [1, 2, 3, 4, 5, 6, 7, 8];
  claimMedicalDocumentSettings: UploaderSettings = new UploaderSettings();
  claimSummaryFamilyDoctorSettings: UploaderSettings = new UploaderSettings();
  showErrors: boolean = false; //temp

  constructor(injector: Injector) {

    super(injector);
  }

  ngOnInit() {

    this.baseAbstractControl = new FormGroup({
      SinceYears: new FormControl('', []),
      During: new FormControl('', []),
      TreatedBy: new FormControl('', []),
      TreatedByAddress: new FormControl('', []),
      MedicalSummaryDocument: new FormControl('', []),
      ProvingDocuments: new FormArray([new FormControl()]),
      //TreatedFamilyMembers: new FormArray([new FormControl()]),
      //Witnesses: new FormArray([new FormControl()]),

      PersonalLetter: new FormControl('', [])
    });

    this.baseAbstractControl.valueChanges.subscribe(val => {
      this.changed.forEach(f => f(val));
    });
    

  

    this.claimSummaryFamilyDoctorSettings = {

      allowMimeTypes: ['application/pdf', 'image/bmp', 'image/gif', 'image/tiff', 'image/jpeg', 'image/png'],
      maxFileSize: 10 * 1024 * 1024, //10MB
      queueLimit: 1,
      queueMinLimit: 1,
      hasDescription: false,
      isDescriptionRequired: false,
      isMultiple: false,
      isRequired: true,
      isSigned:false
    }
    this.claimMedicalDocumentSettings = {

      allowMimeTypes: ['application/pdf', 'image/bmp', 'image/gif', 'image/tiff', 'image/jpeg', 'image/png'],
      maxFileSize: 10 * 1024 * 1024, //10MB
      queueLimit: 1,
      queueMinLimit: 1,
      hasDescription: true,
      isDescriptionRequired: false,
      isMultiple: false,
      isRequired: true,
      isSigned:false
    }

    super.ngOnInit();
  }

  addProvingDocumentsToArray() {

    (<FormArray>this.baseAbstractControl['controls'].ProvingDocuments).push(new FormControl());
  }

  removeProvingDocumentsFromArray(index) {

    const control = <FormArray>this.baseAbstractControl['controls'].ProvingDocuments;
    control.removeAt(index);
  }

  addFamilyMemberToArray() {
    (<FormArray>this.baseAbstractControl['controls'].TreatedFamilyMembers).push(new FormControl());
  }
  removeFamilyMemberFromArray(index) {
    const control = <FormArray>this.baseAbstractControl['controls'].TreatedFamilyMembers;
    control.removeAt(index);
  }

 addWitnessesToArray() {
   (<FormArray>this.baseAbstractControl['controls'].Witnesses).push(new FormControl());
  }
  removeWitnessesFromArray(index) {
    const control = <FormArray>this.baseAbstractControl['controls'].Witnesses;
    control.removeAt(index);
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/claim/clm-claim/clm-claim.component.ts